module.exports = __webpack_public_path__ + "img/logo-azul.1d5fd6d5.png";